import { Form } from "react-bootstrap";
import { Controller, UseControllerProps } from "react-hook-form";

import { LabelForm, LabelFormProps } from "./LabelForm.tsx";

interface InputProps {
  label: string;
}

type SwitchProps = UseControllerProps & InputProps & LabelFormProps;

const Switch = (props: SwitchProps) => {
  return (
    <div className="form-switch_layout">
      <LabelForm label={props.label} />
      <Controller
        control={props.control}
        name={props.name}
        render={({ field: { onChange, value } }) => {
          return (
            <Form.Check
              checked={value}
              onChange={onChange}
              type="switch"
              defaultValue={props.defaultValue}
            />
          );
        }}
        defaultValue={props.defaultValue}
      />
    </div>
  );
};

export default Switch;
